<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: 'performanceAssignmentList' }">绩效分配</el-breadcrumb-item>
                <el-breadcrumb-item>绩效分配{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                    :class="in_array(item['prop'], ['product_rid']) ? 'is-required' : ''"
                                    v-show="
                                        formData['object_type_code'] == 5 ||
                                        (formData['object_type_code'] != 5 && !in_array(item.prop, ['product_rid']))
                                    "
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'parent_rid'"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        :extend="formData[fieldTypeMap[item.prop]['extend']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                    class="is-required"
                                    v-show="in_array(formData['object_type_code'], [5, 6, 7, 8, 9])"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="绩效分配行" name="2" style="margin-top: 20px">
                    <vPerformanceAssignmentLineComponent
                        ref="performance_assignment_line_ref"
                        v-if="flag"
                        :postList="performance_assignment_line_params"
                    ></vPerformanceAssignmentLineComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit, checkNumber } from '@/js/common.js';
import vPerformanceAssignmentLineComponent from '@/components/page/listComponent/basicdata/performance/performanceAssignmentLineComponent.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'performanceAssignmentEdit',
    components: {
        vPerformanceAssignmentLineComponent,
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1', '2'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {}, // 表单验证信息
            flag: false,
            performance_assignment_line_params: {}
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();

        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.getObjectData();
        }
        this.initFormRule();
        this.initSubListParams();
        this.selectedColData(); //筛选列
    },
    mounted() {
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {
        in_array,
        initSubListParams() {
            this.performance_assignment_line_params.params = {
                performance_assignment_rid: this.$route.query.id,
                type: this.type
            };
        },
        onDropChange(key, value) {
            this.formData[key] = value;
            if (key == 'object_type_code') {
                this.formData.object_rid = '';
                this.formData.product_rid = '';
                this.formData.start_date = '';
                this.formData.end_date = '';
                this.$refs.product_rid_ref[0].reset();
                this.$refs.object_rid_ref[0].reset();
                this.$refs.object_rid_ref[0].extend_plus = { object_type_code: value };
            }
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                object_type_code: {
                    request_uri: 'dropdownAssignmentObjectType',
                    title: '对象类型',
                    ref: 'object_type_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                object_rid: {
                    request_uri: 'searchAssignmentObject',
                    title: '对象',
                    ref: 'object_rid_ref',
                    type: 'search_select',
                    default_option_key: 'object_option',
                    extend: { object_type_code: this.data.object_type_code || '' }
                },
                product_rid: {
                    request_uri: 'dropdownProducts',
                    title: '产品',
                    ref: 'product_rid_ref',
                    type: 'dropdown',
                    request_params: { type_code: [11, 15, 91] }
                },
                start_date: {
                    title: '开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'start_date_ref',
                    type: 'date'
                },
                end_date: {
                    title: '结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'end_date_ref',
                    type: 'date'
                }
            };
        },
        initFormRule() {
            this.rules = {
                performance_unit_code: [{ required: true, message: '请选择绩效单元编码', trigger: 'blur' }],
                object_type_code: [{ required: true, message: '请选择对象类型', trigger: 'blur' }],
                object_rid: [{ required: true, message: '请选择对象', trigger: 'blur' }],
                percent: { required: true, validator: checkNumber, trigger: 'blur' }
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                object_type_code: this.data.object_type_code || '',
                object_rid: this.data.object_rid || '',
                product_rid: this.data.product_rid || '',
                start_date: this.data.start_date || '',
                end_date: this.data.end_date || '',
                object_option: { rid: this.data.object_rid || '', name: this.data.object_number || '' }
            };
            this.initFieldTypeMap();
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).performance_assignment;

            processColDataToEdit(
                temp,
                this,
                {
                    white: ['performance_unit_code', 'percent', 'object_rid', 'object_type_code', 'start_date', 'end_date']
                },
                {
                    product: 'product_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: 'performanceAssignmentList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .performanceAssignmentDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        getObjectData() {
            if (this.$route.query.object_type_code && this.$route.query.object_rid) {
                this.$api
                    .searchAssignmentObject({
                        extend: { object_type_code: this.$route.query.object_type_code, object_rid: this.$route.query.object_rid }
                    })
                    .then((res) => {
                        if (res.code == 0 && res.data) {
                            this.data = {
                                object_type_code: parseInt(this.$route.query.object_type_code),
                                object_rid: this.$route.query.object_rid,
                                object_number: res.data[0]['name']
                            };
                        }
                        this.initFormData();
                    })
                    .catch((error) => {});
            } else {
                this.initFormData();
            }
        },
        //提交新增/编辑修改
        submit(formName) {
            if (this.formData.object_type_code == 5) {
                if (this.formData.product_rid == '' || this.formData.start_date == '' || this.formData.end_date == '') {
                    this.$message({
                        message: '当对象类型为绩效单元时，产品、目标对象类型、开始日期、结束日期必填',
                        type: 'error'
                    });
                    return false;
                }
            } else if (in_array(this.formData.object_type_code, [6, 7, 8, 9])) {
                if (this.formData.start_date == '' || this.formData.end_date == '') {
                    this.$message({
                        message: '当对象类型为PPAP或绩效归属时，开始日期、结束日期必填',
                        type: 'error'
                    });
                    return false;
                }
            }

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'performanceAssignmentUpdate';
            } else {
                uri = 'performanceAssignmentInsert';
            }

            var temp = this.$refs.performance_assignment_line_ref.tableData || [];
            this.formData.data = [];

            temp.forEach((element) => {
                // 只要有任意一个不是null，就请求，如有缺失，后端报错
                // 如果全为null，则过滤行
                if (
                    !(!element.performance_unit_code && !element.business_unit_code && (element.percent === null || element.percent === ''))
                ) {
                    this.formData.data.push(element);
                }
            });

            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>